import React from 'react';
import { CTAButton } from './CTAButton';
import { CountdownTimer } from './CountdownTimer';
import { ScarcityBar } from './ScarcityBar';
export function FinalCTA() {
  return <section className="w-full bg-navy-900 px-4 py-14 text-white" data-id="element-86" data-mp="c6sm5lmdmgey">
      <div className="mx-auto flex max-w-2xl flex-col items-center text-center" data-id="element-87" data-mp="c83pxlftno62">
        <h2 className="font-display text-[27px] font-bold leading-tight sm:text-4xl" data-id="element-88" data-mp="84e433qj7koq">
          Cada consulta es una oportunidad para tomar una{' '}
          <span className="italic text-gold-light" data-id="element-89" data-mp="h5vi8gkdpcas">mejor decisión</span>.
        </h2>
        <p className="mt-4 text-[15px] leading-relaxed text-white/70" data-id="element-90" data-mp="h413jjzpagf5">
          La diferencia entre improvisar y actuar con confianza muchas veces está en tener el sistema
          adecuado al alcance de la mano.
        </p>
        <p className="mt-3 text-[15px] leading-relaxed text-white/70" data-id="element-91" data-mp="14uwru74y6thn">
          Comienza hoy a seguir una Ruta Clínica diseñada para simplificar el manejo de la obesidad.
        </p>
        <p className="mt-5 text-[16px] font-semibold text-white sm:text-lg" data-id="element-92" data-mp="2c4oc0yv5lb79">
          Obtén acceso inmediato al Kit Clínico para el Manejo de la Obesidad por solo{' '}
          <span className="text-gold-light" data-id="element-93" data-mp="2h3zqg181s4lo">$15 USD</span>.
        </p>
        <p className="mt-2 text-[12px] text-white/55" data-id="element-94" data-mp="2m1t1p8o7jost">
          El cambio de moneda se aplica automáticamente según tu país.
        </p>

        <div className="mt-7 flex w-full flex-col items-center gap-4" data-id="element-95" data-mp="2qzuj7p5zjg26">
          <CTAButton label="QUIERO EL KIT CLÍNICO AHORA" sublabel="Descarga inmediata • Pago único • Acceso de por vida • Garantía de 7 días" onDark data-id="element-96" data-mp="2v2zhffj18vl0" />
          <CountdownTimer data-id="element-97" data-mp="34tu58obxg38k" />
          <ScarcityBar spotsLeft={9} data-id="element-98" data-mp="34vexg7arra39" />
        </div>
      </div>
    </section>;
}